<template>
  <div>
    <query-form
      :data="formData"
      @query="query"
      @reset="reset"
      @batchConfirm="batchConfirm"
    ></query-form>
    <table-list :data="dataList" @query="query" ref="tableList" />
    <v-row justify="end">
      <v-col cols="auto">
        <v-pagination
          v-if="totalPage > 0"
          v-model="formData.pageNum"
          :length="totalPage"
          :total-visible="totalVisible"
          @input="query"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  asgLtcProjectList,
  getReportTypes,
  asgLtcConfirmReport,
} from "@/plugins/api";
import queryForm from "./queryForm.vue";
import tableList from "./tableList.vue";

export default {
  data() {
    return {
      dataList: [],
      formData: {
        status: "-1", //    状态值查询
        projectNo: "", //     项目方案号
        contractNo: "", //     合同编号
        pageSize: 10,
        pageNum: 1,
      },
      validDays: 350, // 完成日期+350天  之内视作未超期
      typeList: [],
      typeMap: {},
      cpxMap: {},
      totalPage: 0, //最大页数
      totalVisible: 10, //最大可见页数
    };
  },
  created() {
    this.init();
  },
  components: { queryForm, tableList },
  methods: {
    async init() {
      this.$store.commit("showLoading");
      // 加载报告类型与ID的对照表
      await getReportTypes().then((res) => {
        let d = res.data;
        this.typeList = d;
        d.forEach((r) => {
          this.typeMap[r.TYPE] = r.ID;
          let cpx = r.CPX;
          if (cpx) {
            let cpxArr = cpx.split("\n");
            cpxArr.forEach((c) => (this.cpxMap[c] = r.TYPE));
          }
        });
      });
      await this.onQueryProject(this.Utility.transForm(this.formData));
    },
    async onQueryProject(params) {
      // this.dataList = [];
      let projects;
      await asgLtcProjectList(params)
        .then((res) => {
          projects = res.data?.projects || [];
          if (projects.length > 0) {
            projects.map((item) => (item.isChecked = false));
          }
          this.$refs.tableList.resetSelectAll();
          this.totalPage = res.data?.totalPage;
        })
        .finally(() => this.projectLoadAfter(projects));
    },
    async projectLoadAfter(projects) {
      let _dataList = [];
      if (!projects) projects = [];
      let len = projects.length;
      if (!len) {
        this.$store.commit("hideLoading");
        return;
      }
      for (let i = 0; i < len; i++) {
        let project = projects[i];
        project.rule = project.rule ? JSON.parse(project.rule) : project.rule
        _dataList.push(project);
      }
      this.dataList = _dataList;
      this.$store.commit("hideLoading");
    },
    async onReloadItem(item, idx) {
      this.$set(this.dataList, idx, item);
    },
    reset() {
      this.formData = Object.assign({}, this.formData, {
        status: "-1", //    状态值查询
        projectNo: "", //     项目方案号
        contractNo: "", //     合同编号
        pageSize: 10,
        pageNum: 1,
      });
      this.onQueryProject(this.Utility.transForm(this.formData));
    },
    query() {
      this.onQueryProject(this.Utility.transForm(this.formData));
    },
    //批量确认
    batchConfirm() {
      this.$message.confirm("确定批量确认吗?", () => {
        const params = {
          projectNos: this.dataList
            .filter((item) => item.isChecked)
            .map((item) => item.xmfah),
        };
        asgLtcConfirmReport(params).then(() => {
          this.$message.success("批量确认成功。");
          this.query();
        });
      });
    },
  },
};
</script>
